<template>
  <b-col cols="12" md lg="6" sm="12" order="1" order-md="0">
    <div
      class="text-azul-medio text-uppercase gilmer h5 text-center mt-5 mt-md-3 font-weight-light"
    >
      Postulación {{ anioPostulacion }} - Año académico {{ anioAdmision }}
    </div>
    <div class="bg-azul-claro2 py-4 px-4 h6 text-center rounded ">
      <b-row>
        <b-col cols="12" lg="6">
          <img src="@/assets/img/pantalla.png" class="img-fluid mb-3" alt />
        </b-col>
        <b-col cols="12" lg="6">
          <p class="inicial p-3 h5">
            Revisa aquí todos los establecimientos a los que puedes postular
          </p>
          <router-link
            data-testid="button-ver-establecimientos"
            :to="{ name: 'Vitrina' }"
            class="btn btn-azul-outline text-uppercase font-weight-bold h5"
            >Ver establecimientos</router-link
          >
        </b-col>
      </b-row>
    </div>
    <div class="text-justify p-2 h5">
      Regístrate al sistema desde el 19 de julio y postula desde el
      <strong>10 de agosto</strong>. Recuerda que tienes hasta el 7 de
      septiembre para postular.
    </div>
    <div class="bg-azul-claro py-4 px-4 h6 text-center rounded mt-5 mt-lg-4">
      <a
        :href="ayuda"
        data-testid="enlace-ayuda-mineduc"
        target="_blank"
        class="gilmer h5 font-weight-light"
      >
        <strong class="col-12 d-inline-block text-azul-medio"
          >¿Dudas para postular?</strong
        >
        <span
          class="d-inline-block btn btn-azul-outline mt-2 text-uppercase font-weight-bold"
          >Consulta Ayuda Mineduc</span
        >
      </a>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "InformacionRegistro",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA,
      anioPostulacion: "",
      anioAdmision: "",
      inicioPostulacion: "",
      finPostulacion: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.anioPostulacion = obtenerValorLocalStorage("anioPostulacion");
    this.anioAdmision = obtenerValorLocalStorage("anioAdmision");
    this.inicioPostulacion = obtenerValorLocalStorage("inicioPostulacion");
    this.finPostulacion = obtenerValorLocalStorage("finPostulacion");
  }
};
</script>

<style scoped>
.inicial {
  text-align: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/login/InformacionRegistro.vue